import Vue from 'vue'
const moment = require('moment')
require('moment/locale/sk')

Vue.use(require('vue-moment'), {
    moment
})

console.log(Vue.moment().locale()) //sk
